import script from "./CTournamentRegistrationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentRegistrationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentRegistrationPanel.vue?vue&type=style&index=0&id=1d3fd910&lang=less"

const __exports__ = script;

export default __exports__